exports.components = {
  "component---src-pages-jsx": () => import("./../../../src/pages/[...].jsx" /* webpackChunkName: "component---src-pages-jsx" */)
}

